/* Andy Cooks – recipe card interactions (gallery, servings, metric/imperial, cook mode, video, share) */
(function () {
  'use strict';
  var acT = function (k, f, v) { var s = (window.AC_I18N && window.AC_I18N[k]) || f; if (v) { for (var n in v) { s = s.split('__' + n + '__').join(v[n]); } } return s; };
  var root = document.querySelector('[data-acr]');
  if (!root) return;

  /* ---------------- Gallery ---------------- */
  var gal = root.querySelector('[data-acr-gallery]');
  if (gal) {
    var track = gal.querySelector('.acr-gallery__track');
    var slides = track.children;
    var dotsWrap = gal.querySelector('.acr-gallery__dots');
    var count = slides.length;
    gal.setAttribute('data-count', count);
    var dots = [];
    for (var i = 0; i < count && count > 1; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', acT('ac.js.recipe_card.show_photo', 'Show photo __n__', { n: i + 1 }));
      (function (idx) { d.addEventListener('click', function () { go(idx); }); })(i);
      dotsWrap.appendChild(d); dots.push(d);
    }
    var cur = 0;
    function go(idx) { idx = (idx + count) % count; track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' }); }
    function sync() {
      cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach(function (b, j) { b.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    gal.querySelector('.acr-gallery__nav--prev').addEventListener('click', function () { go(cur - 1); });
    gal.querySelector('.acr-gallery__nav--next').addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(cur - 1); if (e.key === 'ArrowRight') go(cur + 1); });
    sync();
  }

  /* ---------------- Jump buttons / reviews link ---------------- */
  root.querySelectorAll('[data-acr-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', a.getAttribute('href')); }
    });
  });
  root.querySelectorAll('[data-acr-goto-reviews]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector('#bbcomments-container, #comments, .shopify-app-block [id*="comment"]');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ---------------- Ingredient parsing ---------------- */
  var UF = { '½': .5, '⅓': 1 / 3, '⅔': 2 / 3, '¼': .25, '¾': .75, '⅛': .125, '⅜': .375, '⅝': .625, '⅞': .875, '⅕': .2, '⅖': .4, '⅗': .6, '⅘': .8, '⅙': 1 / 6, '⅚': 5 / 6 };
  var UFC = Object.keys(UF).join('');
  var NUM = '(?:\\d+(?:[.,]\\d+)?\\s*[' + UFC + ']|\\d+\\s+\\d+\\/\\d+|\\d+\\/\\d+|\\d+(?:[.,]\\d+)?|[' + UFC + '])';
  var UNITS = 'kilograms?|kgs?|grams?|g|mg|millilitres?|milliliters?|mls?|litres?|liters?|l|tablespoons?|tbsps?|tbs|teaspoons?|tsps?|cups?|fl\\.?\\s?oz|ounces?|oz|pounds?|lbs?|cm|mm|inch(?:es)?|pinch(?:es)?|quarts?|qt|pints?';
  var RE = new RegExp('^\\s*(' + NUM + ')(?:\\s*(?:-|–|to)\\s*(' + NUM + '))?\\s*(' + UNITS + ')?\\.?(?=[\\s,()]|$)', 'i');

  function pn(s) {
    s = s.replace(',', '.').trim();
    var m;
    if ((m = s.match(new RegExp('^(\\d+(?:\\.\\d+)?)\\s*([' + UFC + '])$')))) return parseFloat(m[1]) + UF[m[2]];
    if (UF[s] !== undefined) return UF[s];
    if ((m = s.match(/^(\d+)\s+(\d+)\/(\d+)$/))) return +m[1] + m[2] / m[3];
    if ((m = s.match(/^(\d+)\/(\d+)$/))) return m[1] / m[2];
    return parseFloat(s);
  }
  function canon(u) {
    if (!u) return '';
    u = u.toLowerCase().replace(/\s|\./g, '');
    if (/^(kg|kgs|kilogram|kilograms)$/.test(u)) return 'kg';
    if (/^(g|gram|grams)$/.test(u)) return 'g';
    if (u === 'mg') return 'mg';
    if (/^(ml|mls|millilitre|millilitres|milliliter|milliliters)$/.test(u)) return 'ml';
    if (/^(l|litre|litres|liter|liters)$/.test(u)) return 'l';
    if (/^(tbsp|tbsps|tbs|tablespoon|tablespoons)$/.test(u)) return 'tbsp';
    if (/^(tsp|tsps|teaspoon|teaspoons)$/.test(u)) return 'tsp';
    if (/^cups?$/.test(u)) return 'cup';
    if (/^floz$/.test(u)) return 'floz';
    if (/^(oz|ounce|ounces)$/.test(u)) return 'oz';
    if (/^(lb|lbs|pound|pounds)$/.test(u)) return 'lb';
    if (u === 'cm' || u === 'mm') return u;
    if (/^inch/.test(u)) return 'inch';
    if (/^pinch/.test(u)) return 'pinch';
    if (/^(quart|quarts|qt)$/.test(u)) return 'quart';
    if (/^pints?$/.test(u)) return 'pint';
    return u;
  }
  var METRIC = { g: 1, kg: 1, mg: 1, ml: 1, l: 1, cm: 1, mm: 1 };
  var IMPERIAL = { oz: 1, lb: 1, floz: 1, inch: 1, quart: 1, pint: 1 };

  function parseQty(str) {
    var m = str.match(RE);
    if (!m) return null;
    return { a: pn(m[1]), b: m[2] ? pn(m[2]) : null, unit: canon(m[3]), len: m[0].length };
  }
  function parseLine(text) {
    var q = parseQty(text);
    if (!q || isNaN(q.a)) return { name: text, q: null };
    var rest = text.slice(q.len);
    var alt = null;
    var pm = rest.match(/^\s*\(([^)]*)\)/);
    if (pm) {
      var aq = parseQty(pm[1]);
      if (aq && !isNaN(aq.a) && aq.unit && pm[1].slice(aq.len).trim() === '') { alt = aq; rest = rest.slice(pm[0].length); }
    }
    rest = rest.replace(/^\s*[,\-–]\s*/, '').replace(/^of\s+/i, '').trim();
    q.alt = alt;
    return { name: rest || text, q: q };
  }

  /* ---------------- Conversion & formatting ---------------- */
  function convert(v, unit, system) {
    if (system === 'imperial' && METRIC[unit]) {
      switch (unit) {
        case 'g': var oz = v / 28.3495; return oz >= 16 ? [oz / 16, 'lb'] : [oz, 'oz'];
        case 'kg': return [v * 2.20462, 'lb'];
        case 'ml': if (v >= 60) return [v / 250, 'cup']; if (v >= 15) return [v / 15, 'tbsp']; return [v / 5, 'tsp'];
        case 'l': return [v * 4, 'cup'];
        case 'cm': return [v / 2.54, 'inch'];
      }
    }
    if (system === 'metric' && IMPERIAL[unit]) {
      switch (unit) {
        case 'oz': var g = v * 28.3495; return g >= 1000 ? [g / 1000, 'kg'] : [g, 'g'];
        case 'lb': var g2 = v * 453.592; return g2 >= 1000 ? [g2 / 1000, 'kg'] : [g2, 'g'];
        case 'floz': return [v * 29.5735, 'ml'];
        case 'quart': return [v * 0.946353, 'l'];
        case 'pint': return [v * 473.176, 'ml'];
        case 'inch': return [v * 2.54, 'cm'];
      }
    }
    return [v, unit];
  }
  var FR = [[0, ''], [.125, '⅛'], [.25, '¼'], [1 / 3, '⅓'], [.5, '½'], [2 / 3, '⅔'], [.75, '¾'], [1, '']];
  function frac(v) {
    if (v >= 10) return String(Math.round(v));
    var w = Math.floor(v), f = v - w, best = FR[0], bd = 9;
    FR.forEach(function (p) { var d = Math.abs(f - p[0]); if (d < bd) { bd = d; best = p; } });
    if (best[0] === 1) { w += 1; best = FR[0]; }
    if (w === 0 && !best[1]) return '⅛';
    return (w ? String(w) : '') + best[1];
  }
  function dec(v, places) { var p = Math.pow(10, places); return String(Math.round(v * p) / p); }
  function fmtNum(v, unit) {
    switch (unit) {
      case 'g': case 'ml': return v >= 100 ? String(Math.round(v / 5) * 5) : v >= 10 ? String(Math.round(v)) : dec(v, 1);
      case 'kg': case 'l': return dec(v, 2);
      case 'mg': return String(Math.round(v));
      case 'oz': return v >= 4 ? String(Math.round(v)) : frac(v);
      case 'lb': return dec(v, 2);
      case 'cm': case 'mm': return v >= 10 ? String(Math.round(v)) : dec(v, 1);
      default: return frac(v);
    }
  }
  var LBL = { g: 'g', kg: 'kg', mg: 'mg', ml: 'ml', l: 'L', cm: 'cm', mm: 'mm', tbsp: acT('ac.js.recipe_card.unit_tbsp', ' tbsp'), tsp: acT('ac.js.recipe_card.unit_tsp', ' tsp'), oz: 'oz', floz: acT('ac.js.recipe_card.unit_floz', ' fl oz'), inch: '"', pinch: acT('ac.js.recipe_card.unit_pinch', ' pinch'), quart: acT('ac.js.recipe_card.unit_qt', ' qt'), pint: acT('ac.js.recipe_card.unit_pt', ' pt') };
  function unitLabel(unit, v) {
    if (unit === 'cup') return v > 1 ? acT('ac.js.recipe_card.unit_cups', ' cups') : acT('ac.js.recipe_card.unit_cup', ' cup');
    if (unit === 'lb') return v > 1 ? acT('ac.js.recipe_card.unit_lbs', ' lbs') : acT('ac.js.recipe_card.unit_lb', ' lb');
    return LBL[unit] !== undefined ? LBL[unit] : (unit ? ' ' + unit : '');
  }
  function render(q, factor, system) {
    var src = q;
    var target = system;
    if (q.alt) {
      var altSys = METRIC[q.alt.unit] ? 'metric' : IMPERIAL[q.alt.unit] ? 'imperial' : null;
      var mainSys = METRIC[q.unit] ? 'metric' : IMPERIAL[q.unit] ? 'imperial' : null;
      if (altSys === system && mainSys !== system) src = q.alt;
    }
    var a = convert(src.a * factor, src.unit, target);
    var out = fmtNum(a[0], a[1]);
    if (src.b != null) { var b = convert(src.b * factor, src.unit, target); out += '–' + fmtNum(b[0], b[1]); a[0] = b[0]; }
    return out + unitLabel(a[1], a[0]);
  }

  var items = [];
  root.querySelectorAll('.acr-ing__name[data-raw]').forEach(function (el) {
    var p = parseLine(el.getAttribute('data-raw').replace(/,\s*,/g, ','));
    var qtyEl = el.parentNode.querySelector('.acr-ing__qty');
    el.textContent = p.name;
    items.push({ el: el, qtyEl: qtyEl, q: p.q });
  });

  /* ---------------- Measurements written inside the directions and notes (5mm, 180°C, 20 x 30cm tin, 200ml...) ----------------
     These follow the metric/imperial switch too (no scaling with serves). A measurement that already has its
     conversion in brackets, e.g. "180°C (350°F)", is left alone. */
  var convs = [];
  var MEAS = /(\d+(?:[.,]\d+)?)(?:\s*(?:x|×|by)\s*(\d+(?:[.,]\d+)?))?(?:\s*(?:-|–|to)\s*(\d+(?:[.,]\d+)?))?(\s*)(°\s*[CF]|º\s*[CF]|degrees?\s*(?:celsius|fahrenheit|[CF])|[CF]|mm|cm|millimetres?|millimeters?|centimetres?|centimeters?|inch(?:es)?|kg|kilograms?|g|grams?|ml|millilitres?|milliliters?|litres?|liters?|l|oz|ounces?|lbs?|pounds?|fl\.?\s?oz)(?![a-zA-Z])/gi;
  function measUnit(u) {
    var x = u.toLowerCase().replace(/[\s.]/g, '');
    if (/^(°|º)?c$|^degrees?(c|celsius)$/.test(x)) return 'C';
    if (/^(°|º)?f$|^degrees?(f|fahrenheit)$/.test(x)) return 'F';
    if (/^(mm|millimet(re|er)s?)$/.test(x)) return 'mm';
    if (/^(cm|centimet(re|er)s?)$/.test(x)) return 'cm';
    if (/^inch/.test(x)) return 'inch';
    return canon(x);
  }
  function inches(v) {
    var e = Math.round(v * 8);
    if (v >= 4) return String(Math.round(v));   /* tins and trays: whole inches */
    if (v < 1) { var F8 = ['⅛', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞', '1']; return F8[Math.max(1, e)]; }
    var w = Math.floor(v), q = Math.round((v - w) * 4);
    if (q === 4) { w += 1; q = 0; }
    return w + ['', '¼', '½', '¾'][q];
  }
  function measText(m, sys) {
    var u = m.u, nums = m.n, out;
    if (u === 'C' || u === 'F') {
      if ((u === 'C') === (sys === 'metric')) return null;
      /* oven temperatures land on the usual dial settings (180°C = 350°F, 200°C = 400°F); cooler temps (meat, oil) to the nearest 5 */
      return nums.map(function (v) {
        if (u === 'C') { var f = v * 9 / 5 + 32; return v >= 100 ? Math.round(f / 25) * 25 : Math.round(f / 5) * 5; }
        var c = (v - 32) * 5 / 9; return v >= 212 ? Math.round(c / 10) * 10 : Math.round(c / 5) * 5;
      }).join(m.sep) + (u === 'C' ? '°F' : '°C');
    }
    if (u === 'mm' || u === 'cm') {
      if (sys === 'metric') return null;
      var big = 0;
      out = nums.map(function (v) { var i = (u === 'mm' ? v / 10 : v) / 2.54; big = Math.max(big, i); return inches(i); }).join(m.sep);
      return out + (big > 1 ? acT('ac.js.recipe_card.unit_inches', ' inches') : acT('ac.js.recipe_card.unit_inch', ' inch'));
    }
    if (u === 'inch') {
      if (sys === 'imperial') return null;
      return nums.map(function (v) { return dec(v * 2.54, 1); }).join(m.sep) + 'cm';
    }
    if ((METRIC[u] && sys === 'imperial') || (IMPERIAL[u] && sys === 'metric')) {
      var last = null;
      out = nums.map(function (v) { var c = convert(v, u, sys); last = c; return fmtNum(c[0], c[1]); }).join(m.sep);
      return out + unitLabel(last[1], last[0]);
    }
    return null;
  }
  function wrapMeasurements(scope) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null), nodes = [], t;
    while ((t = walker.nextNode())) { if (!t.parentNode.closest('.acr-num, .acr-sr, .acr-conv') && /\d/.test(t.nodeValue)) nodes.push(t); }
    nodes.forEach(function (node) {
      var text = node.nodeValue, frag = null, last = 0, mm;
      MEAS.lastIndex = 0;
      while ((mm = MEAS.exec(text))) {
        var u = measUnit(mm[5]);
        if ((u === 'C' || u === 'F') && /^[CF]$/i.test(mm[5]) && (mm[4] || parseFloat(mm[1]) < 90)) continue;   /* bare "C"/"F" only right after an oven temperature, e.g. 180C */
        if (!(u === 'C' || u === 'F' || u === 'mm' || u === 'cm' || u === 'inch' || METRIC[u] || IMPERIAL[u])) continue;
        var before = text.slice(0, mm.index).replace(/\s+$/, ''), after = text.slice(mm.index + mm[0].length);
        if (/\($/.test(before) || /^\s*\(\s*(?:about\s*|approx\.?\s*|~\s*)?\d/i.test(after)) continue;   /* conversion already given */
        var nums = [parseFloat(mm[1].replace(',', '.'))], sep = '';
        if (mm[2]) { nums.push(parseFloat(mm[2].replace(',', '.'))); sep = ' x '; }
        else if (mm[3]) { nums.push(parseFloat(mm[3].replace(',', '.'))); sep = '–'; }
        if (!frag) frag = document.createDocumentFragment();
        frag.appendChild(document.createTextNode(text.slice(last, mm.index)));
        var span = document.createElement('span');
        span.className = 'acr-conv';
        span.textContent = mm[0];
        frag.appendChild(span);
        convs.push({ el: span, orig: mm[0], u: u, n: nums, sep: sep });
        last = mm.index + mm[0].length;
      }
      if (frag) { frag.appendChild(document.createTextNode(text.slice(last))); node.parentNode.replaceChild(frag, node); }
    });
  }
  root.querySelectorAll('.acr-dir__box, .acr-notes__block').forEach(wrapMeasurements);

  var base = parseFloat(root.getAttribute('data-serves')) || 0;
  var serves = base;
  /* measurements: default from the visitor's country (US, Liberia, Myanmar use imperial), a toggle only lasts for this visit */
  var IMP_COUNTRY = { US: 1, LR: 1, MM: 1 };
  var country = ((window.Shopify && Shopify.country) || '').toUpperCase();
  var system = IMP_COUNTRY[country] ? 'imperial' : 'metric';
  try { var picked = sessionStorage.getItem('ac-units'); if (picked === 'imperial' || picked === 'metric') system = picked; localStorage.removeItem('ac-units'); } catch (e) {}

  var out = root.querySelector('[data-acr-serves-out]');
  var unitsBtn = root.querySelector('[data-acr-units]');
  var knob = root.querySelector('[data-acr-units-knob]');
  var unitsLbl = root.querySelector('[data-acr-units-label]');
  var minusBtn = root.querySelector('[data-acr-serves="-1"]');

  function update() {
    var factor = base ? serves / base : 1;
    items.forEach(function (it) { it.qtyEl.textContent = it.q ? render(it.q, factor, system) : ''; });
    convs.forEach(function (c) { var t = measText(c, system); c.el.textContent = t || c.orig; c.el.classList.toggle('is-converted', !!t); });
    if (out) out.textContent = serves;
    if (minusBtn) minusBtn.disabled = serves <= 1;
    if (unitsBtn) {
      var imp = system === 'imperial';
      unitsBtn.setAttribute('aria-checked', imp ? 'true' : 'false');
      knob.textContent = imp ? acT('ac.js.recipe_card.knob_imperial', 'LBS') : acT('ac.js.recipe_card.knob_metric', 'KG');
      unitsLbl.textContent = imp ? acT('ac.js.recipe_card.imperial', 'Imperial') : acT('ac.js.recipe_card.metric', 'Metric');
    }
    try { root.dispatchEvent(new CustomEvent('acr:prefs', { detail: { serves: serves, base: base, system: system } })); } catch (e) {}
  }
  function setServes(n) { serves = Math.max(1, Math.min(99, Math.round(n) || serves)); update(); }
  function setSystem(sys) {
    system = sys === 'imperial' ? 'imperial' : 'metric';
    try { sessionStorage.setItem('ac-units', system); } catch (e) {}
    update();
  }
  function getPrefs() { return { serves: serves, base: base, system: system }; }
  root.querySelectorAll('[data-acr-serves]').forEach(function (b) {
    b.addEventListener('click', function () { serves = Math.max(1, Math.min(99, serves + parseInt(b.getAttribute('data-acr-serves'), 10))); update(); });
  });
  if (unitsBtn) unitsBtn.addEventListener('click', function () { setSystem(system === 'metric' ? 'imperial' : 'metric'); });
  /* serves always starts at the recipe's own amount, even when the browser restores the page from back/forward */
  window.addEventListener('pageshow', function (e) { if (e.persisted && serves !== base) { serves = base; update(); } });
  update();

  /* ---------------- Steps: tap any step to follow along one at a time (bubble + Next step) ---------------- */
  var cookBtn = root.querySelector('[data-acr-cook]');
  var stepLis = [].slice.call(root.querySelectorAll('.acr-steps li'));
  var nextBtn = document.createElement('button');
  nextBtn.type = 'button';
  nextBtn.className = 'acr-nextbtn';
  var ARROW = '<span class="acr-nextbtn__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 5v13M6 12l6 6 6-6"/></svg></span>';
  var TICK = '<span class="acr-nextbtn__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7"/></svg></span>';
  var walking = false;
  function currentStep() { return stepLis.filter(function (li) { return li.classList.contains('is-next'); })[0]; }
  function advance() {
    var cur = currentStep();
    if (!cur) return;
    if (stepLis.indexOf(cur) === stepLis.length - 1) { stopWalk(); showDone(); return; }
    cur.classList.add('is-done');
    markNext();
    var nxt = currentStep();
    if (nxt) { nxt.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { nextBtn.focus({ preventScroll: true }); }, 350); }
  }
  function stepBack() {
    var i = stepLis.indexOf(currentStep());
    if (i <= 0) return;
    setPageIndex(i - 1);
    stepLis[i - 1].scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { nextBtn.focus({ preventScroll: true }); }, 350);
  }
  nextBtn.addEventListener('click', function (e) { e.stopPropagation(); advance(); });
  /* computers: Enter or Down arrow = next step, Up arrow = back a step, while following the steps (cook mode has its own keys) */
  document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || document.documentElement.classList.contains('acm-open')) return;
    if (!currentStep()) return;
    var t = e.target;
    if (t.closest && t.closest('input, textarea, select, [contenteditable="true"]')) return;
    if (e.key === 'Enter') {
      if (t === nextBtn || (t.closest && t.closest('a, button:not(.acr-nextbtn)'))) return;   /* buttons and links keep their normal Enter */
      e.preventDefault(); advance();
    } else if (e.key === 'ArrowDown') { e.preventDefault(); advance(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); stepBack(); }
  });
  function markNext() {
    var started = walking || root.classList.contains('acr--cooking') || stepLis.some(function (li) { return li.classList.contains('is-done'); });
    root.classList.toggle('acr--started', started);
    var found = false, cur = null;
    stepLis.forEach(function (li) {
      var next = started && !found && !li.classList.contains('is-done');
      if (next) { found = true; cur = li; }
      li.classList.toggle('is-next', next);
    });
    if (cur) {
      var remaining = stepLis.filter(function (li) { return !li.classList.contains('is-done'); }).length;
      nextBtn.innerHTML = (remaining > 1 ? acT('ac.js.recipe_card.next_step', 'Next step') : acT('ac.js.recipe_card.done', 'Done')) + (remaining > 1 ? ARROW : TICK);
      nextBtn.setAttribute('aria-label', remaining > 1 ? acT('ac.js.recipe_card.next_step_label', 'Mark this step done and go to the next step') : acT('ac.js.recipe_card.last_step_label', 'Mark the last step done'));
      cur.appendChild(nextBtn);
    } else if (nextBtn.parentNode) {
      nextBtn.parentNode.removeChild(nextBtn);
    }
  }
  /* keep the screen awake while someone is following the steps */
  var stepLock = null;
  function lockOn() {
    if (stepLock || !('wakeLock' in navigator)) return;
    navigator.wakeLock.request('screen').then(function (l) { stepLock = l; l.addEventListener('release', function () { stepLock = null; }); }).catch(function () {});
  }
  function lockOff() { if (stepLock) { stepLock.release().catch(function () {}); stepLock = null; } }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && walking) lockOn(); });
  /* finishing (or tapping the current step again) puts the list back to normal */
  function stopWalk() {
    walking = false;
    lockOff();
    stepLis.forEach(function (li) { li.classList.remove('is-done'); });
    markNext();
  }
  function setPageIndex(i, allDone) {
    stepLis.forEach(function (li, j) { li.classList.toggle('is-done', allDone || j < i); });
    markNext();
  }
  stepLis.forEach(function (li, i) {
    li.tabIndex = 0;
    li.title = acT('ac.js.recipe_card.step_title', 'Tap to follow this recipe step by step');
    function pick() {
      hideDone();
      if (li.classList.contains('is-next')) { stopWalk(); return; }
      walking = true;
      lockOn();
      setPageIndex(i);
    }
    li.addEventListener('click', function (e) { if (e.target.closest('a, .acr-nextbtn')) return; pick(); });
    li.addEventListener('keydown', function (e) {
      if (e.target !== li) return;
      if (e.key === 'Enter' && li.classList.contains('is-next')) return;   /* Enter on the current step moves on (handled above) */
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });
  });
  /* small nudge on step 1 so people know they can tap to start */
  if (stepLis[0]) {
    var hint = document.createElement('span');
    hint.className = 'acr-stephint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<span class="acr-stephint__dot"></span>' + acT('ac.js.recipe_card.tap_to_start', 'Tap to start');
    stepLis[0].appendChild(hint);
  }

  /* ---------------- Finished! a little celebration after the last step ---------------- */
  var DONE_LINES = [
    acT('ac.js.recipe_card.done_line_1', 'Now sit back and enjoy your fantastic efforts.'),
    acT('ac.js.recipe_card.done_line_2', 'You nailed it. Time to tuck in and enjoy every bite.'),
    acT('ac.js.recipe_card.done_line_3', 'Plate it up, share it round and soak up the compliments.'),
    acT('ac.js.recipe_card.done_line_4', 'Cooked with your own two hands. Enjoy every mouthful.'),
    acT('ac.js.recipe_card.done_line_5', 'That’s how it’s done, chef. Now dig in.')
  ];
  var recipeTitle = ((root.querySelector('.acr-title') || {}).textContent || '').trim();
  var doneEl = null;
  function doneLine() { return DONE_LINES[Math.floor(Math.random() * DONE_LINES.length)]; }
  function hideDone() { if (doneEl) { doneEl.remove(); doneEl = null; } }
  function showDone() {
    hideDone();
    var box = root.querySelector('.acr-dir__box');
    if (!box) return;
    doneEl = document.createElement('div');
    doneEl.className = 'acr-done';
    doneEl.setAttribute('role', 'status');
    doneEl.innerHTML =
      '<div class="acr-done__confetti" aria-hidden="true">' + new Array(28).join('<i></i>') + '</div>' +
      '<span class="acr-done__badge" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7"/></svg></span>' +
      '<p class="acr-done__k">' + acT('ac.js.recipe_card.recipe_complete', 'Recipe complete') + '</p>' +
      '<h3 class="acr-done__h">' + doneLine() + '</h3>' +
      (recipeTitle ? '<p class="acr-done__p">' + acT('ac.js.recipe_card.ready', 'Your __title__ is ready. Bon appétit!', { title: recipeTitle.replace(/[&<>"]/g, '') }) + '</p>' : '') +
      '<div class="acr-done__acts">' +
        '<button type="button" class="acr-done__btn acr-done__btn--main" data-done-rate>' + acT('ac.js.recipe_card.rate_recipe', 'Rate this recipe') + '</button>' +
        '<button type="button" class="acr-done__btn" data-done-share>' + acT('ac.js.recipe_card.share', 'Share') + '</button>' +
      '</div>';
    box.parentNode.insertBefore(doneEl, box.nextSibling);
    [].forEach.call(doneEl.querySelectorAll('.acr-done__confetti i'), function (c, k) {
      c.style.left = (Math.random() * 100) + '%';
      c.style.animationDelay = (Math.random() * 0.5) + 's';
      c.style.setProperty('--x', (Math.random() * 120 - 60) + 'px');
      c.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
      c.className = 'c' + (k % 4);
    });
    doneEl.querySelector('[data-done-rate]').addEventListener('click', function () {
      var t = document.querySelector('#bbcomments-container, #comments, .shopify-app-block [id*="comment"]');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    /* Share: phones get their own share sheet; otherwise jump to the "Share this recipe" panel */
    doneEl.querySelector('[data-done-share]').addEventListener('click', function () {
      var url = (document.querySelector('link[rel="canonical"]') || {}).href || location.href.split('?')[0];
      if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
        return;
      }
      var p = document.querySelector('.acs-panel');
      if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    doneEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* Start cooking: jump to step 1 and follow along */
  var startBtn = root.querySelector('[data-acr-start]');
  if (startBtn && stepLis[0]) startBtn.addEventListener('click', function () {
    hideDone();
    walking = true;
    lockOn();
    setPageIndex(0);
    stepLis[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { nextBtn.focus({ preventScroll: true }); }, 450);
  });
  /* Try hands-free mode: opens cook mode (ac-cook-mode.js) with voice switched on */
  if (cookBtn) cookBtn.addEventListener('click', function () {
    setTimeout(function () {
      var v = document.querySelector('.acm [data-acm="voice"]');
      if (v && v.getAttribute('aria-pressed') !== 'true') v.click();
    }, 80);
  });

  /* Cook mode lives in ac-cook-mode.js */
  window.__acr = { root: root, stepLis: stepLis, markNext: markNext, setPageIndex: setPageIndex, cookBtn: cookBtn,
    getPrefs: getPrefs, setServes: setServes, setSystem: setSystem, showDone: showDone, doneLine: doneLine };

  /* ---------------- Video (click to load) ---------------- */
  var vbox = root.querySelector('[data-acr-video]');
  if (vbox) {
    vbox.querySelector('button').addEventListener('click', function () {
      var id = vbox.getAttribute('data-acr-video');
      var start = parseInt(vbox.getAttribute('data-start'), 10) || 0;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0' + (start ? '&start=' + start : '');
      f.title = acT('ac.js.recipe_card.recipe_video', 'Recipe video');
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      vbox.innerHTML = ''; vbox.appendChild(f);
    });
  }

  /* ---------------- Share ---------------- */
  root.querySelectorAll('[data-acr-share]').forEach(function (s) {
    var btn = s.querySelector('.acr-share__btn');
    var bub = s.querySelector('.acr-share__bubble');
    btn.addEventListener('click', function () {
      if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
        navigator.share({ title: document.title, url: s.querySelector('[data-copy]').getAttribute('data-copy') }).catch(function () {});
        return;
      }
      var open = bub.hidden;
      bub.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var copy = s.querySelector('[data-copy]');
    copy.addEventListener('click', function () {
      var tip = copy.querySelector('.acr-share__copied');
      var url = copy.getAttribute('data-copy');
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        tip.textContent = acT('ac.js.recipe_card.link_copied', 'Link copied');
      }).catch(function () { tip.textContent = url; }).then(function () {
        tip.classList.add('is-on'); setTimeout(function () { tip.classList.remove('is-on'); }, 1600);
      });
    });
  });
  /* ---------------- Share panel (bottom): copy link ---------------- */
  root.querySelectorAll('[data-acs-copy]').forEach(function (b) {
    var lbl = b.querySelector('[data-acs-copy-label]');
    b.addEventListener('click', function () {
      var url = b.getAttribute('data-acs-copy');
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        lbl.textContent = acT('ac.js.recipe_card.copied', 'Copied!');
      }).catch(function () { window.prompt(acT('ac.js.recipe_card.copy_prompt', 'Copy this link:'), url); }).then(function () {
        b.classList.add('is-copied');
        setTimeout(function () { lbl.textContent = acT('ac.js.recipe_card.copy_link', 'Copy link'); b.classList.remove('is-copied'); }, 1800);
      });
    });
  });

  /* ---------------- Keep Raptive in-content ads out of the boxed sections ----------------
     If an ad lands inside directions, notes, FAQs or About, move it to just above that section's heading. */
  var CARDS = '.acr-dir__box, .acr-notes__block, .acr-faq, #acr-about .acr-notes';
  function rehome(el) {
    if (!el || el.nodeType !== 1) return;
    var ads = el.matches('[class*="adthrive"], [id^="AdThrive"]') ? [el] : [].slice.call(el.querySelectorAll('[class*="adthrive"], [id^="AdThrive"]'));
    ads.forEach(function (ad) {
      /* never move Raptive's video player: it must stay where Raptive put it or it won't start */
      if (ad.closest('[id^="cls-video-container"], .adthrive-collapse-player, .adthrive-auto-injected-player-container, [class*="raptive-player"], [class*="adthrive-player"]') || /video|player/i.test(ad.id + ' ' + ad.className)) return;
      var card = ad.closest(CARDS);
      if (!card) return;
      var top = ad;
      while (top.parentElement && top.parentElement !== card && /adthrive/i.test(String(top.parentElement.className) + top.parentElement.id)) top = top.parentElement;
      var sec = card.closest('.acr-sec');
      if (sec && sec.parentNode) sec.parentNode.insertBefore(top, sec);
    });
  }
  rehome(root);
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { [].forEach.call(m.addedNodes, rehome); });
    }).observe(root.querySelector('.acr-main') || root, { childList: true, subtree: true });
  }

  /* ---------------- Unfilled Raptive slots ----------------
     Raptive keeps 250px (or more) reserved for each ad. If a slot has been on screen for 6 seconds and still has no ad in it,
     fold the space away so there's no big blank gap; if an ad turns up later, the space opens again. */
  function hasCreative(ad) { return !!ad.querySelector('iframe, img, video, ins, object'); }
  var seen = new WeakMap(), io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { if (e.isIntersecting && !seen.has(e.target)) seen.set(e.target, Date.now()); });
  }, { rootMargin: '0px' }) : null;
  function checkAds() {
    [].forEach.call(document.querySelectorAll('.acr .adthrive-ad:not(.adthrive-footer):not(.adthrive-sidebar)'), function (ad) {
      if (io && !ad.__acObs) { ad.__acObs = 1; io.observe(ad); }
      var full = hasCreative(ad), t = seen.get(ad);
      var fold = !full && t && Date.now() - t > 6000;
      ad.classList.toggle('ac-ad-unfilled', !!fold);
      /* once an ad has loaded, drop the reserved height so the slot hugs the ad (a 320x50 no longer sits in a 250px or 600px box);
         a bigger ad on the next refresh still opens it up again, because the ad's own size sets the height */
      var f = ad.querySelector('iframe');
      ad.classList.toggle('ac-ad-fit', !!(f && f.offsetHeight >= 10));
      var slot = ad.closest('.acr-ad');
      if (slot) slot.classList.toggle('ac-ad-unfilled', !!fold && !slot.querySelector('.adthrive-ad:not(.ac-ad-unfilled)'));
    });
  }
  /* The floating video player normally docks bottom-right. Whenever that spot would cover the right-column ad,
     dock it bottom-left instead (html.ac-player-left, see ac-ads.css), and move it back once the way is clear. */
  function placePlayer() {
    var pl = document.querySelector('.adthrive-collapse-float.adthrive-collapse-bottom-right');
    var sb = document.querySelector('.acr-ad--sidebar .adthrive-ad iframe') || document.querySelector('.acr-ad--sidebar .adthrive-ad');
    var left = false;
    if (pl && sb && window.innerWidth >= 1024) {
      var p = pl.getBoundingClientRect(), a = sb.getBoundingClientRect();
      var pr = document.documentElement.clientWidth - 5, pl0 = pr - p.width;        /* where it sits when docked right */
      left = a.width > 0 && a.left < pr && a.right > pl0 && a.top < p.bottom && a.bottom > p.top;
    }
    document.documentElement.classList.toggle('ac-player-left', left);
  }
  var placeQueued = false;
  window.addEventListener('scroll', function () { if (placeQueued) return; placeQueued = true; requestAnimationFrame(function () { placeQueued = false; placePlayer(); }); }, { passive: true });
  window.addEventListener('resize', placePlayer);

  var checks = 0, timer = setInterval(function () { checkAds(); placePlayer(); if (++checks > 90) clearInterval(timer); }, 2000);  /* first 3 minutes */
  var lastCheck = 0;
  window.addEventListener('scroll', function () { if (checks > 90 && Date.now() - lastCheck > 1500) { lastCheck = Date.now(); checkAds(); } }, { passive: true });
})();
